export default {
  getLabelByName(name) {
    if (name == "") {
      return "";
    }
    let labels = [
      {
        name: " ",
      },
      {
        name: "Discount %",
      },
      {
        name: "3 Mth Avg",
      },
      {
        name: "6 Mth Avg",
      },
      {
        name: "4 Week Avg",
      },
      {
        name: "13 Week Avg",
      },
      {
        name: "ABN",
      },
      {
        name: "APN",
      },
      {
        name: "Account Name",
      },
      {
        name: "Acc No.",
      },
      {
        name: "Active",
      },
      {
        name: "AddressStreet Line 2",
      },
      {
        name: "Agent Ref",
      },
      {
        name: "Agent",
      },
      {
        name: "Agent Code",
      },
      {
        name: "Agent Name",
      },
      {
        name: "Allocated",
      },
      {
        name: "Alternate Product",
      },
      {
        name: "Amount",
      },
      {
        name: "Allocated",
      },
      {
        name: "Apply Freight",
      },
      {
        name: "Associated Accounts",
      },
      {
        name: "Avail Qty",
      },
      {
        name: "Avail",
      },
      {
        name: "Available For Sale",
      },
      {
        name: "Kit Item",
      },
      {
        name: "Available",
      }, // Label Possible Duplicate
      {
        name: "Ave Cost",
      },
      {
        name: "BSB No.",
      },
      {
        name: "Back Order",
      },
      {
        name: "Balance",
      },
      {
        name: "Barcode",
      },
      {
        name: "Batch Date Created",
      },
      {
        name: "Batch Method",
      },
      {
        name: "Batch",
      },
      {
        name: "Bill To Code",
      },
      {
        name: "Bill To Customer",
      },
      {
        name: "Bill To Name",
      },
      {
        name: "Bill To",
      },
      {
        name: "Bin",
      },
      {
        name: "Branch Code",
      },
      {
        name: "Branch Description",
      },
      {
        name: "Branch Name",
      },
      {
        name: "Branch",
      },
      {
        name: "Buy Rate",
      },
      {
        name: "Carton / Layer",
      },
      {
        name: "Carton / Pallet",
      },
      {
        name: "Cat 1 Code",
      },
      {
        name: "Cat 1 Description",
      },
      {
        name: "Cat 2 Code",
      },
      {
        name: "Cat 2 Description",
      },
      {
        name: "Cat 3 Code",
      },
      {
        name: "Cat 3 Description",
      },
      {
        name: "Cat 4 Code",
      },
      {
        name: "Cat 4 Description",
      },
      {
        name: "Categories",
      },
      {
        name: "Category 1 Code",
      },
      {
        name: "Category 1 Description",
      },
      {
        name: "Category 1",
      },
      {
        name: "Category 2 Code",
      },
      {
        name: "Category 2 Description",
      },
      {
        name: "Category 2",
      },
      {
        name: "Category 3 Code",
      },
      {
        name: "Category 3 Description",
      },
      {
        name: "Category 3",
      },
      {
        name: "Category 4 Code",
      },
      {
        name: "Category 4 Description",
      },
      {
        name: "Category 4",
      },
      {
        name: "Changed By",
      },
      {
        name: "Code",
      },
      {
        name: "Comment",
      },
      {
        name: "Commission %",
      },
      {
        name: "Charge",
      },
      {
        name: "Commit Qty",
      },
      {
        name: "Comp",
      },
      {
        name: "Company Name",
      },
      {
        name: "Complete",
      },
      {
        name: "Con Note",
      }, // Label Possible Duplicate
      {
        name: "Confirmation",
      },
      {
        name: "Contact",
      },
      {
        name: "Contract",
      },
      {
        name: "Conversion",
      },
      {
        name: "Corporate Rate",
      },
      {
        name: "Cost (AUD)",
      },
      {
        name: "Count Date",
      },
      {
        name: "Count To Date",
      },
      {
        name: "Count",
      },
      {
        name: "Country",
      },
      {
        name: "Created By",
      },
      {
        name: "Credit Limit",
      },
      {
        name: "Cubic (m³)",
      },
      {
        name: "Currency Code",
      },
      {
        name: "Currency",
      },
      {
        name: "Cust PO",
      },
      {
        name: "Customer Code",
      },
      {
        name: "Customer Country",
      },
      {
        name: "Customer Creditor",
      },
      {
        name: "Customer Group Code",
      },
      {
        name: "Customer Group Description",
      },
      {
        name: "Customer Group",
      },
      {
        name: "Customer Name",
      },
      {
        name: "Customer Self Ref",
      },
      {
        name: "Customer State",
      },
      {
        name: "Customer Type Code",
      },
      {
        name: "Customer Type Description",
      },
      {
        name: "Customer Type Name",
      },
      {
        name: "Customer Type",
      },
      {
        name: "Customer",
      },
      {
        name: "Date / Time",
      },
      {
        name: "Date Adjusted",
      },
      {
        name: "Date Controlled",
      },
      {
        name: "Date Created",
      },
      {
        name: "Date In",
      },
      {
        name: "Date Received",
      },
      {
        name: "Date",
      },
      {
        name: "Default",
      },
      {
        name: "Deliver To",
      },
      {
        name: "Delivery Address",
      },
      {
        name: "Delivery Self Ref",
      },
      {
        name: "Delivery",
      },
      {
        name: "Department",
      },
      {
        name: "Description 1",
      },
      {
        name: "Description 2",
      },
      {
        name: "Description 3",
      },
      {
        name: "Delivery Firm",
      },
      {
        name: "Description",
      },
      {
        name: "Despatch",
      },
      {
        name: "Div",
      },
      {
        name: "Division Code",
      },
      {
        name: "Division Description",
      },
      {
        name: "Division",
      },
      {
        name: "Drawn",
      },
      {
        name: "Duty %",
      },
      {
        name: "Duty Rate",
      },
      {
        name: "ETA",
      },
      {
        name: "Email Credit Note",
      },
      {
        name: "Email Customer Statement",
      },
      {
        name: "Email Delivery Note",
      },
      {
        name: "Email Invoice",
      },
      {
        name: "Email Receipt",
      },
      {
        name: "Email Sales Order",
      },
      {
        name: "Email RRP",
      },
      {
        name: "Credit Note",
      },
      {
        name: "Customer Statement",
      },
      {
        name: "Delivery Note",
      },
      {
        name: "Invoice",
      },
      {
        name: "Receipt",
      },
      {
        name: "Due Date",
      },
      {
        name: "Email",
      },
      {
        name: "End Date",
      },
      {
        name: "Ex Tax (AUD)",
      },
      {
        name: "Exchange Rate",
      },
      {
        name: "Exemption #",
      },
      {
        name: "ETA",
      },
      {
        name: "Feature Access",
      },
      {
        name: "Firm",
      },
      {
        name: "First Name",
      },
      {
        name: "Freight %",
      },
      {
        name: "Freight and Landing Rate",
      },
      {
        name: "From Branch Code",
      },
      {
        name: "From Branch Description",
      },
      {
        name: "From Branch",
      },
      {
        name: "Full Description",
      },
      {
        name: "GP %",
      },
      {
        name: "GP (AUD)",
      },
      {
        name: "GP",
      },
      {
        name: "GST Rate",
      },
      {
        name: "GST",
      },
      {
        name: "Goods In",
      },
      {
        name: "Goods Received",
      },
      {
        name: "Group Code",
      },
      {
        name: "Group Name",
      },
      {
        name: "Group",
      },
      {
        name: "Height (cm)",
      },
      {
        name: "Heigt (cm)",
      },
      {
        name: "ISO Code",
      },
      {
        name: "Inc",
      },
      {
        name: "Invoice",
      },
      {
        name: "Item Code",
      },
      {
        name: "Item Description",
      },
      {
        name: "Item",
      },
      {
        name: "Landing Cost %",
      },
      {
        name: "Landing Cost Factor",
      },
      {
        name: "Inv Date",
      },
      {
        name: "Invoice Date",
      },
      {
        name: "Inv Total",
      },
      {
        name: "ISO Code",
      },

      {
        name: "Last Cost",
      },
      {
        name: "Lead Days",
      },
      {
        name: "Length (cm)",
      },
      {
        name: "Line No",
      },
      {
        name: "Line",
      },
      {
        name: "Location Code",
      },
      {
        name: "Location Description",
      },
      {
        name: "Location",
      },
      {
        name: "Lot No",
      },
      {
        name: "Lot Sequence No",
      },
      {
        name: "MLOR Days",
      },
      {
        name: "Manufacturing",
      },
      {
        name: "Margin",
      },
      {
        name: "Max Stock Qty",
      },
      {
        name: "Method",
      },
      {
        name: "Min Stock Qty",
      },
      {
        name: "Mobile",
      },
      {
        name: "Name",
      },
      {
        name: "New Price",
      },
      {
        name: "New Qty",
      },
      {
        name: "Next Status",
      },
      {
        name: "Note 1",
      },
      {
        name: "Note 2",
      },
      {
        name: "Note",
      },
      {
        name: "OS PO Qty",
      },
      {
        name: "On Hand",
      },
      {
        name: "Order No",
      },
      {
        name: "Order",
      },
      {
        name: "Ordered",
      },
      {
        name: "Outstanding",
      },
      {
        name: "Payment Status",
      },
      {
        name: "PG ID",
      },
      {
        name: "POT Mths",
      },
      {
        name: "POT Qty",
      },
      {
        name: "Packing/Storage",
      },
      {
        name: "OS PO Qty",
      },
      {
        name: "Price Group Code",
      },
      {
        name: "Price Group Description",
      },
      {
        name: "Phone",
      },
      {
        name: "Physical Address",
      },
      {
        name: "PhysicalAddressCountry",
      },
      {
        name: "PhysicalAddressPostcode",
      },
      {
        name: "PhysicalAddressState",
      },
      {
        name: "PhysicalAddressStreetLine1",
      },
      {
        name: "PhysicalAddressSuburb",
      },
      {
        name: "PO",
      },
      {
        name: "Position",
      },
      {
        name: "Post Code",
      },
      {
        name: "Postcode",
      },
      {
        name: "Price Group Code",
      },
      {
        name: "POT Mths",
      },
      {
        name: "POT Qty",
      },
      {
        name: "Price Group",
      },
      {
        name: "Price",
      },
      {
        name: "Process Invoice",
      },
      {
        name: "Prod Cat 1 Code",
      },
      {
        name: "Prod Cat 1 Description",
      },
      {
        name: "Prod Cat 1",
      },
      {
        name: "Prod Cat 2 Code",
      },
      {
        name: "Prod Cat 2 Description",
      },
      {
        name: "Prod Cat 2",
      },
      {
        name: "Prod Cat 3 Code",
      },
      {
        name: "Prod Cat 3 Description",
      },
      {
        name: "Prod Cat 3",
      },
      {
        name: "Prod Cat 4 Code",
      },
      {
        name: "Prod Cat 4 Description",
      },
      {
        name: "Prod Cat 4",
      },
      {
        name: "Prod Type Code",
      },
      {
        name: "Prod Type Description",
      },
      {
        name: "Prod Type",
      },
      {
        name: "Product",
      },
      // Label Possible Duplicate - delete and use Item?
      {
        name: "Purchase Account Code",
      },
      {
        name: "Purchase Account Description",
      },
      {
        name: "Purchase Account",
      },
      {
        name: "Purchase Order",
      },
      {
        name: "Qty Change",
      },
      {
        name: "Qty",
      },
      {
        name: "Quantity",
      },
      {
        name: "ROP",
      },
      {
        name: "Rank",
      },
      {
        name: "Received",
      },
      {
        name: "Ref No",
      },
      {
        name: "Remit Contact",
      },
      {
        name: "Remit Email",
      },
      {
        name: "Remittances",
      },
      {
        name: "Reorder Point",
      },
      {
        name: "Reorder Qty",
      },
      {
        name: "Rep Code",
      },
      {
        name: "Rep Name",
      },
      {
        name: "Rep",
      },
      {
        name: "Report",
      },
      {
        name: "Reqd By",
      },
      {
        name: "Reqd Date",
      },
      {
        name: "Required By",
      },
      {
        name: "Run Number",
      },
      {
        name: "SO Type",
      },
      {
        name: "SOH Account Code",
      },
      {
        name: "SOH Account Description",
      },
      {
        name: "SOH Account",
      },
      {
        name: "SSCC",
      },
      {
        name: "ROP",
      },
      {
        name: "Sales Account Code",
      },
      {
        name: "Sales Account Description",
      },
      {
        name: "Sales Account",
      },
      {
        name: "Sales Order",
      },
      {
        name: "Sales Rep Code",
      },
      {
        name: "Sales Rep Name",
      },
      {
        name: "Sales Rep",
      },
      {
        name: "Sales UM",
      },
      {
        name: "Sales/Purchasing",
      },
      {
        name: "Sell End Date",
      },
      {
        name: "Sell Rate",
      },
      {
        name: "Sell Start Date",
      },
      {
        name: "Sequence",
      },
      {
        name: "Settings",
      },
      {
        name: "Ship Date",
      },
      {
        name: "Site",
      },
      {
        name: "Size Code",
      },
      {
        name: "Size Description",
      },
      {
        name: "Size",
      },
      {
        name: "SO #",
      },
      {
        name: "SOH Account Code",
      },
      {
        name: "SOH Account Description",
      },
      {
        name: "SOH Account",
      },
      {
        name: "SSCC",
      },
      {
        name: "Standard Cost",
      },
      {
        name: "Standard Sell",
      },
      {
        name: "Start Date",
      },
      {
        name: "State",
      },
      {
        name: "Status",
      },
      {
        name: "Stock Account",
      },
      {
        name: "Stock Item",
      },
      {
        name: "Stock Movt Account Code",
      },
      {
        name: "Stock Movt Account Description",
      },
      {
        name: "Stock Movt Account",
      },
      {
        name: "Stock On Hand",
      },
      {
        name: "Stock UM",
      },
      {
        name: "Stop Credit",
      },
      {
        name: "Intra Company",
      },
      {
        name: "Street 1",
      },
      {
        name: "Street 2",
      },
      {
        name: "Street Line 1",
      },
      {
        name: "Street Line 2",
      },
      {
        name: "Street Line1",
      },
      {
        name: "Street Line2",
      }, // Label Possible Duplicate
      {
        name: "Suburb",
      },
      {
        name: "Sup Item",
      },
      {
        name: "Sup Price",
      },
      {
        name: "Supp Batch No",
      },
      {
        name: "Supplier Batch",
      },
      {
        name: "Supplier Code",
      },
      {
        name: "Supplier Conversion",
      },
      {
        name: "Supplier Country",
      },
      {
        name: "Supplier Item",
      },
      {
        name: "Supplier Name",
      },
      {
        name: "Supplier Price",
      },
      {
        name: "Supplier State",
      },
      {
        name: "Supplier Type Code",
      },
      {
        name: "Supplier Type Description",
      },
      {
        name: "Supplier Type",
      },
      {
        name: "Supplier UM Price",
      },
      {
        name: "Supplier UM",
      },
      {
        name: "Supplier",
      },
      {
        name: "SupplierCode",
      },
      {
        name: "Surname",
      },
      {
        name: "Statement",
      },
      {
        name: "TUN for Carton",
      },
      {
        name: "Tax Category",
      },
      {
        name: "Tax Code Description",
      },
      {
        name: "Tax Code",
      },
      {
        name: "Term Days",
      },
      {
        name: "Term Method",
      },
      {
        name: "Terms Days",
      },
      {
        name: "Terms Method",
      },
      {
        name: "Terms",
      },
      {
        name: "To Branch Code",
      },
      {
        name: "To Branch Description",
      },
      {
        name: "To Branch",
      },
      {
        name: "To Return",
      },
      {
        name: "Tran #",
      },
      {
        name: "Transit Days",
      },
      {
        name: "Type Code",
      },
      {
        name: "Type Description",
      },
      {
        name: "Type Name",
      },
      {
        name: "Type",
      },
      {
        name: "UM Code",
      },
      {
        name: "UM Description",
      },
      {
        name: "UM",
      },
      {
        name: "Unit Price",
      },
      {
        name: "Unit of Measure",
      },
      {
        name: "Use By Date",
      },
      {
        name: "Use Market $",
      },
      {
        name: "User Type",
      },
      {
        name: "User",
      },
      {
        name: "Value",
      },
      {
        name: "Variable",
      },
      {
        name: "Variance",
      },
      {
        name: "View",
      },
      {
        name: "WET Rate",
      },
      {
        name: "WET",
      },
      {
        name: "Wastage",
      },
      {
        name: "Weight (kg)",
      },

      {
        name: "Type Name",
      },
      {
        name: "",
      },
      {
        name: "To Branch Code",
      },
      {
        name: "To Branch Description",
      },
      {
        name: "From Branch Code",
      },
      {
        name: "From Branch Description",
      },
      {
        name: "Division",
      },
      {
        name: "Contract",
      },
      {
        name: "Start Date",
      },
      {
        name: "End Date",
      },
      {
        name: "Use Market $",
      },
      {
        name: "Drawn",
      },
      {
        name: "Drawn Ordered",
      },
      {
        name: "Drawn Invoiced",
      },
      {
        name: "Qty Change",
      },
      {
        name: "New Qty",
      },
      {
        name: "New Price",
      },
      {
        name: "Comment",
      },
      {
        name: "Tran #",
      },
      {
        name: "Agent Ref",
      },
      {
        name: "Confirmation",
      },
      {
        name: "Delivery",
      },
      {
        name: "Qty",
      },
      {
        name: "Available",
      },
      {
        name: "Report",
      },
      {
        name: "Width (cm)",
      },
      {
        name: "Update All Branches",
      },
      {
        name: "Product Category 1",
      },
      {
        name: "Product Category 2",
      },
      {
        name: "Product Category 3",
      },
      {
        name: "Product Category 4",
      },
      {
        name: "Product Type",
      },
      {
        name: "Start Date >=",
      },
      {
        name: "Visible On Invoice",
      },
      {
        name: "Customer Sell",
      },
      {
        name: "Carton Quantity",
      },
      {
        name: "Best Before Date",
      },
      {
        name: "Customer Rep",
      },

      {
        name: "Order Rep",
      },
      { name: "Fiscal Year" },
      { name: "Account" },
      { name: "Account Description" },
      { name: "Month" },
      { name: "Opening Balance" },
      { name: "Closing Balance" },
      { name: "MTD Budget" },
      { name: "YTD Budget" },
      { name: "Movement" },
      { name: "Transaction Type" },
      { name: "Transaction Reference" },
      { name: "Transaction" },
      {
        name: "Date Committed",
      },
      {
        name: "Std Cost Stock UM",
      },
      {
        name: "Std Cost Sales UM",
      },
      {
        name: "Std Sell Sales UM",
      },
      {
        name: "Std Sell Stock UM",
      },
      { name: "Product Type Code" },
      { name: "Product Type Description" },
      { name: "Customer Rep Code" },
      { name: "Customer Rep Name" },
      { name: "Week" },
      { name: "Quarter" },
      { name: "Calendar Year" },
      { name: "Items" },
      { name: "Product Size" },
      { name: "Product Size Code" },
      { name: "Product Size Description" },
      { name: "Fiscal Month" },
      { name: "Product Filter Group" },
      {
        name: "Customer PO",
      },
      {
        name: "Month/Fiscal Year",
      },
      { name: "Discount" },
      {
        name: "Season",
      },
      {
        name: "Card",
      },
      {
        name: "Container",
      },
      {
        name: "Product Code",
      },
      {
        name: "Product Name",
      },
      {
        name: "Moisture",
      },
      {
        name: "In Stock?",
      },
      {
        name: "Location Name",
      },
      {
        name: "Site Code",
      },
      {
        name: "Site Name",
      },
      {
        name: "Grade",
      },
      {
        name: "Net Kg",
      },
      {
        name: "Last Move",
      },
      {
        name: "Drop Code",
      },
      {
        name: "Sales Order Code",
      },
      {
        name: "Sales Order Line",
      },
      {
        name: "Stock UM Order Qty",
      },
      {
        name: "Stock UM Picked Qty",
      },
      {
        name: "Stock UM Back Order Qty",
      },
      {
        name: "Sales UM Order Qty",
      },
      {
        name: "Sale UM Picked Qty",
      },
      {
        name: "Sales UM Back Order Qty",
      },
      {
        name: "Line Total",
      },
      {
        name: "Taxable Line Total",
      },
      {
        name: "Taxable Back Order Line Total",
      },
      { name: "Order Rep Code" },
      { name: "Order Rep Name" },
      { name: "Review" },
      { name: "Promotion" },
      { name: "Promotion Start Date" },
      { name: "Promotion End Date" },
      { name: "Commited Date" },
      { name: "Credit Note" },
      { name: "Delivery Note" },
      { name: "Customer Statement" },
      { name: "Receipt" },
      { name: "SOH Account" },
      { name: "To" },
      { name: "Sales UM Order Qty" },
      { name: "Sales UM Picked Qty" },
      { name: "Sales UM Back Order Qty" },
      { name: "Taxable Line Total" },
      { name: "Taxable Back Order Line Total" },
      { name: "Line Total" },
      { name: "Stock UM Order Qty" },
      { name: "Stock UM Picked Qty" },
      { name: "Stock UM Back Order Qty" },
      { name: "Required By Date" },
      { name: "Sales Order Line" },
      {
        name: "Customer Group Name",
      },
      { name: "Drop" },
      { name: "Drop Code" },
      { name: "Stock Group 2" },
      { name: "Stock UM Order Qty" },
      { name: "Stock UM Picked Qty" },
      { name: "Stock UM Back Order Qty" },
      { name: "Division Name" },
      { name: "Drop Name" },
      { name: "Account Code" },
      { name: "Delivery Company" },
      { name: "Bill To Customer Code" },
      { name: "Bill To Customer Name" },
      { name: "Market" },
      { name: "Reporting Group 1" },
      { name: "Reporting Group 2" },
      { name: "Reporting Group 3" },
      { name: "Region" },
      { name: "Region" },
      { name: "Sub Region" },
      { name: "Accrual Account" },
      { name: "Planning %" },
      { name: "RRP" },
      { name: "RRP Conversion" },
      { name: "Email Purchase Order" },
      { name: "Email Remittance" },
      { name: "Email Invoice / RCTI" },
      { name: "Purchase Description" },
      { name: "Preferred Supplier" },
      { name: "Default Branch" },
      // { name: "Drop" },
      { name: "Purchase Description 1" },
      { name: "Purchase Description 2" },
      { name: "Source" },
      { name: "Default Pack Qty" },
      { name: "Cost Price" },
      { name: "Production BOM" },
      { name: "Planning BOM" },
      { name: "Release Batch Logic" },
      { name: "Shelf Life Method" },
      { name: "Shelf Life Days" },

      { name: "Manufactured Cost" },
      { name: "Full Cost" },
      { name: "Material" },
      { name: "Labour" },
      { name: "Factory Overhead" },
      { name: "Manufacturing Overhead" },
      { name: "Manufactured Cost" },
      { name: "Sale Overhead" },
      { name: "Admin Overhead" },
      { name: "Full Cost" },
      { name: "Delivery Instructions" },
      { name: "Adjustment" },
      { name: "Stocktake Run" },
      { name: "Default Sales Unit" },
      { name: "Default Production Unit" },
      { name: "Production Unit" },
      { name: "Variable Unit" },
      { name: "Default Production Unit" },
      { name: "Completed By" },
      {
        name: "Prime Cost"
      },
      { name: "Markup %" },
      { name: "Storage Temp" },
      { name: "Release Batch Method" },
      { name: "Stock Journal" },
      { name: "Ex Stock Material" },
    ];

    let label = labels.find((a) => a.name == name);

    if (label) {
      return label.name;
    } else {
      alert("LABEL ERROR - Cannot find label: " + name);
      return "LABEL ERROR";
    }
  },
};
